module.exports = __webpack_public_path__ + "static/primer-counter-button-b99cccfa53c4d484425f870eefeabfed.png";